module.exports = __webpack_public_path__ + "img/manageIcon.b5d532f2.png";